import CONFIG from '@/config/global';

export const createDiscoverPageTitle = () => `${ CONFIG.appName } | Discover the world’s music, for free`;

export const createDiscoverPageDescription = () => `Push the boundaries of your listening. ${ CONFIG.appName } is a free music streaming service that curates the best DJ mixes and radio shows from around the world.`;